import gql from 'graphql-tag';
import { BankAccountFragment } from '../fragments/bank.fragment';
import { PageFragment } from '../fragments/page.fragment';

export const GET_BANK_ACCOUNTS = gql`
    query (
        $paging: CursorPaging
        $filter: BankAccountFilter
        $sorting: [BankAccountSort!]
    ) {
        bankAccounts (
            paging: $paging
            filter: $filter
            sorting: $sorting
        ) {
            pageInfo {
                ...Page
            }
            edges {
                node {
                    ...BankAccountInfo
                }
            }
        }
    }
    ${BankAccountFragment}
    ${PageFragment}
`;